/* @flow */

import React from "react";

import LinkContainer from "../../../general/LinkContainer";
import { MenuItem } from "../../../../datatypes/MenuItem";

type Props = {
    item: MenuItem;
};

class MenuListSublist extends React.Component<Props> {
    renderHeadline(group: MenuItem) {
        if (group.relativeURL) {
            return (
                <LinkContainer key={group.id + "headline-0"} to={group.relativeURL}>
                    <h3>{group.name}</h3>
                </LinkContainer>
            );
        } else if (group.absoluteURL) {
            return (
                <a key={group.id + "headline-0"} href={group.absoluteURL}>
                    <h3>{group.name}</h3>
                </a>
            );
        }
        return null;
    }

    renderChildLink(item: MenuItem, index: number) {
        if (item.relativeURL) {
            return (
                <LinkContainer key={`${item.id}${String(index)}`} to={item.relativeURL} customClass="test-item ">
                    {item.name}
                </LinkContainer>
            );
        } else if (item.absoluteURL) {
            return (
                <a key={`${item.id}${String(index)}`} className="test-item" href={item.absoluteURL}>
                    {item.name}
                </a>
            );
        }
        return null;
    }

    render() {
        let key = 0;
        return (
            <div className="mfcss_menu-mega-item">
                {this.renderHeadline(this.props.item)}
                {(this.props.item.children ?? []).map((child) => {
                    return this.renderChildLink(child, key++);
                })}
            </div>
        );
    }
}

export default MenuListSublist;
